// extracted by mini-css-extract-plugin
export default {"BlockchainData":"styles_BlockchainData__N88-c","BlockchainDataItem":"styles_BlockchainDataItem__cVlpZ"};